import algoliasearch from 'algoliasearch/lite';

export const searchClient = algoliasearch(
  'N8R8D9EGXQ',
  'dcd698797ce64e6f46def3e286ae16ae'
);
export const indexName = 'calfoodie';
export const index = searchClient.initIndex(indexName);
